import { Capacitor } from "@capacitor/core";
import type { BannerAdProvider } from "@yjsgames/ad-ports";
import { LazyBannerProvider, NoopBannerProvider } from "@yjsgames/ad-ports";
import type { LevelPlayBannerOptions } from "./levelPlayAdsPlugin.js";

export interface BannerAdProviderConfig {
  readonly levelPlay: LevelPlayBannerOptions;
}

/**
 * 배너 Provider 결정 (DIP 플랫폼 분기 팩토리) — 보상형 `createRewardedAdProvider`와 동형.
 * - **웹/데스크톱**: `NoopBannerProvider` 즉시 반환 (네이티브 SDK 번들 제외 + 모바일 전용 게이트).
 *   웹 CrazyGames 배너는 별도 `CrazyGamesBannerProvider`로 `createShellSystems`에서 직접 생성한다.
 * - **네이티브**: `LevelPlayBannerProvider`를 dynamic import로 로드 (AdMob 직접 배너 → LevelPlay 미디에이션 전환).
 *   import 완료 전 호출(show/remove)은 마지막 의도(`desired`)를 기억했다가 주입 직후 1회 적용.
 *
 * 게임/셸은 반환된 `BannerAdProvider`(Port)에만 의존하고 구체 구현/로딩 시점을 모른다.
 */
export function createBannerAdProvider(config: BannerAdProviderConfig): BannerAdProvider {
  if (!Capacitor.isNativePlatform()) return new NoopBannerProvider();
  return new LazyBannerProvider(
    async () => {
      const { LevelPlayBannerProvider } = await import("./LevelPlayBannerProvider.js");
      return new LevelPlayBannerProvider(config.levelPlay);
    },
    { warn: (message) => console.warn(message) },
  );
}
